import React from "react";
import { Steps } from "antd";
import { CheckCircleOutlined, ClockCircleOutlined, FileTextOutlined } from "@ant-design/icons";

const { Step } = Steps;

interface SourcingStepperProps {
  currentStep: number;
  onStepChange: (step: number) => void;
  completedSteps: boolean[];
  steps: {
    title: string;
    description: string;
    icon?: React.ReactNode;
  }[];
}

export const SourcingStepper: React.FC<SourcingStepperProps> = ({
  currentStep,
  onStepChange,
  completedSteps,
  steps,
}) => {
  const getStepStatus = (index: number) => {
    if (index < currentStep) return "finish";
    if (index === currentStep) return "process";
    return "wait";
  };

  const getStepIcon = (index: number) => {
    if (completedSteps[index]) return <CheckCircleOutlined />;
    if (index === currentStep) return <ClockCircleOutlined />;
    return <FileTextOutlined />;
  };

  return (
    <div style={{ marginBottom: 24 }}>
      <Steps current={currentStep} size="small">
        {steps.map((step, index) => (
          <Step
            key={index}
            title={step.title}
            description={step.description}
            status={getStepStatus(index)}
            icon={getStepIcon(index)}
          />
        ))}
      </Steps>
    </div>
  );
};